import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Loadable from 'react-loadable';

import Loading from '../components/Loading';

const IndexPage = Loadable({
    loader: () => import('../pages/IndexPage/IndexPage'),
    loading: Loading
});

const FiveModulePage = Loadable({
    loader: () => import('../pages/FiveModulePage/FiveModulePage'),
    loading: Loading
});

const ThreeGroupsPage = Loadable({
    loader: () => import('../pages/ThreeGroupsPage/ThreeGroupsPage'),
    loading: Loading
});

const ContactPage = Loadable({
    loader: () => import('../pages/ContactPage/ContactPage'),
    loading: Loading
});

const ContactArticlePage = Loadable({
    loader: () => import('../pages/ContactPage/ContactArticlePage'),
    loading: Loading
});

const AboutPage = Loadable({
    loader: () => import('../pages/AboutPage/AboutPage'),
    loading: Loading
});

const PartnershipPage = Loadable({
    loader: () => import('../pages/PartnershipPage/PartnershipPage'),
    loading: Loading
});





export default class Routes extends React.Component{
    render(){
        return(
            <Switch>
                <Route exact path="/" component={IndexPage}/>
                <Route path="/five" component={FiveModulePage}/>
                <Route path="/three" component={ThreeGroupsPage}/>
                <Route exact path="/contact" component={ContactPage}/>
                <Route path="/contact/:articleId" component={ContactArticlePage}/>
                <Route path="/about" component={AboutPage}/>
                <Route path="/partnership" component={PartnershipPage}/>
            </Switch>
        )
    }
}

